import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    marginBottom: ['25px', '87px'],
    marginTop: ['25px', '87px'],
    padding: ['0px 20px', 'inherit'],

    // '.left-col': {
    //   marginRight: [null, '37px', '78px'],
    // },
  },
  title: {
    color: 'violet.100',
    textAlign: 'center',
    marginBottom: ['20px', '100px'],
  },
  flexContainer: {
    flexDirection: ['column', 'row'],
    alignItems: ['center'],
  },
  imageContainer: {
    display: ['none', 'block'],
    width: ['100%'],
    flex: '1',
    maxWidth: '698px',
    marginLeft: [null, '59px', '118px'],
    '&.left-col': {
      marginLeft: '0px',
      marginRight: [null, '59px', '118px'],
    },
  },
  responsiveImageContainer: {
    display: ['block', 'none'],
    margin: ['32px auto 32px auto', '15px auto 15px auto'],
  },
  image: {
    img: {
      objectFit: 'contain !important',
    },
    // maxHeight: ['360px', '550px'],
  },
  contentContainer: {
    color: 'black.100',
    textAlign: ['center', 'left'],
    flex: '1',
  },
  contentTitle: {
    marginBottom: ['48px', '18px'],
  },
  contentSubtitle: {
    marginBottom: ['20px', '30px'],
  },
  contentContent: {
    marginBottom: ['40px', '60px'],
    marginTop: ['40px', null],
  },
  contentCta: {
    margin: ['24px auto 64px auto', 'inherit'],
  },
};
